import { Modal, ModalHeader, ModalBody, Form, Button, Row, Col } from 'reactstrap';
import { isMobileOnly } from 'react-device-detect';
import useModal from '../../../sharedComponents/useModal/useModal';
import { Theme } from '../../../config/constants';
import { toast } from 'react-toastify';
import reportingApi from '../../../api/reportingApi';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../../reducers/ModalsReducer/ModalsActions';
import { useNavigate } from 'react-router-dom';

const DeleteReportModal = ({id, ...props}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { modalProps, headerProps } = useModal(id, {header: {color: 'black', background: 'white'}});
    const { reportId, parentPage } = props;

    const handleClickCancel = () => {
        dispatch(hideModal(id));
    };

    const handleDeleteReport = () => {
        reportingApi.deleteReport.delete(reportId).then(() => {
            toast.success('Report deleted');
            dispatch(hideModal(id));
            navigate(`/${parentPage}`);
        }).catch(err => {
            toast.error(err.data.message || 'Something went wrong deleting the report. Try again later.');
            console.error(err);
        });
    };

    return (
        <Modal  {...modalProps}>
            <ModalHeader {...headerProps}>Delete Report</ModalHeader>
            <ModalBody >
                <Form className= {(isMobileOnly ? 'px-2 text-size-16' : 'px-5 text-size-16')} >
                    <Row>
                        <Col>
                            <div>Are you sure you want to delete this report? This action CANNOT be undone.</div>
                        </Col>
                    </Row>
                    <Row className='py-2 mx-auto'>
                        <Col>
                            <Button onClick={() => {handleClickCancel()}} block color={Theme().colors.primaryName} className='py-2 px-2 button-label'>Cancel</Button>
                        </Col>
                        <Col>
                            <Button onClick={() => {handleDeleteReport()}} block color={Theme().colors.accentName} className='py-2 px-2 button-label'>Delete Report</Button>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
};

export default DeleteReportModal;